<template>
  <div>
    <van-tabs v-model="active" @change="handleClick">
      <van-tab title="申领明细"></van-tab>
      <van-tab title="使用明细"></van-tab>
    </van-tabs>
    <van-list style="padding-top: 10px" v-model="loading" :finished="finished"  finished-text="没有更多了" @load="onLoad" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item, index) in list" :key="index" >
        <div style="display: flex; align-items: center; height:100%; width:100%">
          <div style="flex: 1;" v-if="active == 0">
            <div class="custName-wrap" style="padding: 0;">
              <div class="custName">
                {{item.deptName}}
              </div>
              <van-tag type="success" style="margin-left:10px" plain>通过</van-tag>
            </div>
            <div style="color: #999; font-size: 12px">申请人：{{item.applyName}}   申请数量：{{item.applyCount}}</div>
            <div style="color: #999; font-size: 12px">申请时间：{{ item.applyTime | timeFormat }}</div>
          </div>
          <div style="flex: 1;" v-if="active == 1">
            <div class="custName-wrap" style="padding: 0;">
              <div class="custName">
                {{item.contractName}} {{item.contractNum}}
              </div>
            </div>
            <div style="color: #999; font-size: 12px">使用人：{{item.applyName}}   使用数量：{{item.useCount}}</div>
            <div style="color: #999; font-size: 12px">使用时间：{{ item.applyTime | timeFormat }}</div>
          </div>
          <!-- <van-icon style="flex:0.1;" color="#c1c1c1" name="arrow" size="16" class="arrow-color" /> -->
        </div>
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
  </div>
</template>

<script>
import moment from "moment"
import {listApplyCont, listApplyUsed} from "@/api/cont/contract"
import EmptyComponent from "@/components/common/Empty"
import TotalComponent from "@/components/common/Total"
import { Tab, Tabs  } from 'vant'
export default {
  name: "decordDetail",
  components: {
    EmptyComponent,TotalComponent,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  filters: {
    timeFormat(val) {
      return moment(val).format("YYYY-MM-DD");
    }
  },
  data() {
    return {
      isEmpty: false,
      active: 0,
      loading: false,
      finished: false,
      list: [],
      total: 0,
      showFilterPop: false,
      custList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        verifyStatus: 1,
        deptId: '',
        serviceTypeId: '',
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    };
  },
  created(){
    this.queryParams.deptId = this.$route.query.deptId
    this.queryParams.serviceTypeId = this.$route.query.serviceTypeId
    this.handleList()
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
       document.title = "申领合同记录详情"
    },
    queryCustList() {
      this.list = [];
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = 10;
      this.handleList();
    },
    async handleList() {
      this.loading = true;
      if(this.active == 0){
        this.queryParams.verifyStatus = 1
        const res = await listApplyCont(this.queryParams);
        if (res.code === 200) {
          if (res.rows.length === 0) {
            this.isEmpty = true
          } else {
            this.isEmpty = false
          }
          this.list = this.list.concat(...res.rows); 
          this.queryParams.pageNum += 1;
          this.total = res.total;
          this.finished = this.list.length >= res.total;
        }
      }else if(this.active == 1){
        delete this.queryParams.verifyStatus
        const res = await listApplyUsed(this.queryParams);
        if (res.code === 200) {
          if (res.rows.length === 0) {
            this.isEmpty = true
          } else {
            this.isEmpty = false
          }
          this.list = this.list.concat(...res.rows); 
          this.queryParams.pageNum += 1;
          this.total = res.total;
          this.finished = this.list.length >= res.total;
        }
      }
      this.loading = false
    },
    onLoad() {
      this.handleList();
    },
    handleClick(tab, event) {
      this.queryCustList()
    }
  },
};
</script>
<style lang="less" scoped>
@import url("@/style/index.less");

.custName-wrap {
  font-size: 12px;
  padding: 5px;
  color: #ccc;
  display: flex;
  justify-content: left;
}

.van-tabs {
  position: relative;
  top: 0;
}
.tips{
  min-width: 3.1rem;
  font-size: .2rem;
  color: rgb(247, 155, 35);
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
.editVisit{
    min-height: 9rem;
    height: 50%;
    top: 46%;
    .formSty{
      height: 100%; overflow: scroll; margin: 10px 5px;
    }
}
.editVisit /deep/.van-dialog__content {
  height: 83%;
  .van-field--error .van-field__control{
    font-size: 0.38rem;
  }
  .van-field__control{font-size: 0.38rem;}
}
.editVisit /deep/.van-dialog__content {
  height: 70%;
}
</style>